module.exports = __webpack_public_path__ + "img/8f9795e.png";